import { QualificationListJSON } from '@scale/shared/types/qualification/types';
import { UseQueryResult, useQuery } from 'react-query';
import apiFetch, { HTTPError, defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';

export const useFetchQualificationLists = (
  {
    projectId,
    teamId,
    enabled,
  }: {
    projectId?: string;
    teamId?: string;
    enabled?: boolean;
  },
  onSuccess?: (res: QualificationListJSON[]) => void,
): UseQueryResult<QualificationListJSON[], unknown> => {
  return useQuery(
    ['fetchQualificationLists', projectId, teamId],
    async () => {
      if (!projectId && !teamId) {
        return [];
      }
      const endpointToUse = projectId
        ? `corp-api/scalers/qualifications/project/${projectId}`
        : `corp-api/scalers/qualifications/worker_team/${teamId}`;

      const result = await apiFetch<QualificationListJSON[]>(null, endpointToUse, {
        method: 'GET',
      });

      return result;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
      enabled: enabled ?? false,
    },
  );
};
